import { TranslationsService } from "./translation-service";
import { en } from "./en";
import { de } from "./de";
const locales = { en, de };
const i18nService = new TranslationsService(locales, 'de');
export default i18nService;
